import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (sessionId) {
        try {
          await processSession(sessionId);
          // Clear the hash and navigate to dashboard
          window.history.replaceState(null, '', '/admin/dashboard');
          navigate('/admin/dashboard', { replace: true });
        } catch (error) {
          navigate('/admin/login', { replace: true });
        }
      } else {
        navigate('/admin/login', { replace: true });
      }
    };

    processAuth();
  }, [location.hash, navigate, processSession]);

  return (
    <div className="min-h-screen bg-[#1a1c1b] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#7dd3fc] animate-spin mx-auto mb-4" />
        <p className="text-[#7dd3fc] text-lg">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
